// The Trailhead template's renderer for every block type.
//
// One entry per type in WebsiteLayout::BLOCK_TYPES, and that is a
// rule rather than a habit: a site switched to Trailhead keeps every
// block it had, so a type missing here would be content that
// silently stops rendering. sitetemplates_verify fails on a gap.
//
// Columns is the one shared component. It draws nothing of its own
// and renders its children through the template-aware registry, so a
// Trailhead column holds Trailhead blocks.

import './trailhead.css';
import ThMenu from './ThMenu.vue';
import ThHero from './ThHero.vue';
import ThStats from './ThStats.vue';
import ThConditions from './ThConditions.vue';
import ThForecast from './ThForecast.vue';
import ThSlider from './ThSlider.vue';
import ThNews from './ThNews.vue';
import ThFindTrail from './ThFindTrail.vue';
import ThEvents from './ThEvents.vue';
import ThSponsors from './ThSponsors.vue';
import ThLocalGuide from './ThLocalGuide.vue';
import ThFeaturesGrid from './ThFeaturesGrid.vue';
import ThSteps from './ThSteps.vue';
import ThCta from './ThCta.vue';
import ThTiqHero from './ThTiqHero.vue';
import ThSmartphone from './ThSmartphone.vue';
import ThFeatureShowcase from './ThFeatureShowcase.vue';
import ThText from './ThText.vue';
import ThTrails from './ThTrails.vue';
import ThPostHero from './ThPostHero.vue';
import ThPostTitle from './ThPostTitle.vue';
import ThPostMeta from './ThPostMeta.vue';
import ThPostExcerpt from './ThPostExcerpt.vue';
import ThPostBody from './ThPostBody.vue';
import ThEventHero from './ThEventHero.vue';
import ThEventTitle from './ThEventTitle.vue';
import ThEventWhen from './ThEventWhen.vue';
import ThEventLocation from './ThEventLocation.vue';
import ThEventExcerpt from './ThEventExcerpt.vue';
import ThEventBody from './ThEventBody.vue';
import ThEventMaintenance from './ThEventMaintenance.vue';
import ThEventSignup from './ThEventSignup.vue';
import ThFooter from './ThFooter.vue';
import ThAlert from './ThAlert.vue';
import ThPageHeader from './ThPageHeader.vue';
import ThDonate from './ThDonate.vue';
import ThGallery from './ThGallery.vue';
import ThFaq from './ThFaq.vue';
import ThContact from './ThContact.vue';
import ThNewsletter from './ThNewsletter.vue';
import ThFollow from './ThFollow.vue';
import ThVolunteerSignup from './ThVolunteerSignup.vue';
import ThQuoteRequest from './ThQuoteRequest.vue';
import ThProjectSpecs from './ThProjectSpecs.vue';
import ThHazards from './ThHazards.vue';
import ThLiveActivity from './ThLiveActivity.vue';
import ThGrooming from './ThGrooming.vue';
import ThMap from './ThMap.vue';
import ThQuickLinks from './ThQuickLinks.vue';
import ThTimeline from './ThTimeline.vue';
import ThColumns from './ThColumns.vue';
import ThButtons from './ThButtons.vue';
import ThSocialPosts from './ThSocialPosts.vue';
import ThShop from './ThShop.vue';
// The Trails page blocks and the trail page's parts draw from
// Trailhead's own tokens when they are there, so one component serves
// both templates.
import TrailDirectoryBlock from '../Blocks/TrailDirectoryBlock.vue';
import TrailTypesBlock from '../Blocks/TrailTypesBlock.vue';
import DifficultyRatingsBlock from '../Blocks/DifficultyRatingsBlock.vue';
import TrailFeaturesBlock from '../Blocks/TrailFeaturesBlock.vue';
import FilesBlock from '../Blocks/FilesBlock.vue';
import { NETWORK_PART_COMPONENTS, TRAIL_PART_COMPONENTS } from '../Blocks/trailParts.js';

export const TRAILHEAD_COMPONENTS = {
    menu: ThMenu,
    hero: ThHero,
    stats: ThStats,
    conditions: ThConditions,
    forecast: ThForecast,
    slider: ThSlider,
    news: ThNews,
    find_trail: ThFindTrail,
    events: ThEvents,
    sponsors: ThSponsors,
    local_guide: ThLocalGuide,
    features_grid: ThFeaturesGrid,
    steps: ThSteps,
    cta: ThCta,
    tiq_hero: ThTiqHero,
    smartphone: ThSmartphone,
    feature_showcase: ThFeatureShowcase,
    text: ThText,
    trails: ThTrails,
    columns: ThColumns,
    post_hero: ThPostHero,
    post_title: ThPostTitle,
    post_meta: ThPostMeta,
    post_excerpt: ThPostExcerpt,
    post_body: ThPostBody,
    event_hero: ThEventHero,
    event_title: ThEventTitle,
    event_when: ThEventWhen,
    event_location: ThEventLocation,
    event_excerpt: ThEventExcerpt,
    event_body: ThEventBody,
    event_maintenance: ThEventMaintenance,
    event_signup: ThEventSignup,
    footer: ThFooter,
    alert: ThAlert,
    page_header: ThPageHeader,
    donate: ThDonate,
    gallery: ThGallery,
    faq: ThFaq,
    // One component for both templates; it reads Trailhead's tokens
    // when they are there, like the Trails page blocks.
    files: FilesBlock,
    contact: ThContact,
    newsletter: ThNewsletter,
    follow: ThFollow,
    volunteer_signup: ThVolunteerSignup,
    quote_request: ThQuoteRequest,
    project_specs: ThProjectSpecs,
    hazards: ThHazards,
    live_activity: ThLiveActivity,
    grooming: ThGrooming,
    map: ThMap,
    quick_links: ThQuickLinks,
    timeline: ThTimeline,
    buttons: ThButtons,
    social_posts: ThSocialPosts,
    shop: ThShop,
    trail_directory: TrailDirectoryBlock,
    trail_types: TrailTypesBlock,
    difficulty_ratings: DifficultyRatingsBlock,
    trail_features: TrailFeaturesBlock,
    trail_header: TRAIL_PART_COMPONENTS.trail_header,
    trail_map: TRAIL_PART_COMPONENTS.trail_map,
    trail_details: TRAIL_PART_COMPONENTS.trail_details,
    trail_about: TRAIL_PART_COMPONENTS.trail_about,
    trail_weather: TRAIL_PART_COMPONENTS.trail_weather,
    trail_hazards: TRAIL_PART_COMPONENTS.trail_hazards,
    trail_nearby: TRAIL_PART_COMPONENTS.trail_nearby,
    ...NETWORK_PART_COMPONENTS,
};
